export const CALLBACK_COPY = {
  en: {
    date: "Preferred date", window: "Time window", timezone: "Your timezone",
    choose: "Choose a window", morning: "Morning · 9 a.m.–noon",
    afternoon: "Afternoon · noon–5 p.m.", either: "Either · 9 a.m.–5 p.m.",
    note: "Weekdays, starting tomorrow. Your preferred window is a request, not a confirmed appointment.",
    success: "Your callback request is on our desk.", requested: "Requested callback",
    next: "We'll reply within one business day to confirm a time with the right expert.",
    errors: {
      callback_invalid_phone: "Enter a phone number with 7–15 digits, including your country code.",
      callback_missing_schedule: "Choose a date, time window, and timezone for your call.",
      callback_invalid_window: "Choose morning, afternoon, or either.",
      callback_invalid_timezone: "Choose a valid timezone.",
      callback_invalid_date: "Choose a valid date.",
      callback_future_required: "Choose a date starting tomorrow in your selected timezone.",
      callback_weekday_required: "Choose a weekday, Monday through Friday.",
    },
  },
  fr: {
    date: "Date souhaitée", window: "Plage horaire", timezone: "Votre fuseau horaire",
    choose: "Choisir une plage horaire", morning: "Matin · 9 h–12 h",
    afternoon: "Après-midi · 12 h–17 h", either: "L'un ou l'autre · 9 h–17 h",
    note: "En semaine, à partir de demain. La plage souhaitée est une demande, pas un rendez-vous confirmé.",
    success: "Votre demande d'appel est sur notre bureau.", requested: "Appel souhaité",
    next: "On vous répond en un jour ouvrable pour confirmer une heure avec le bon expert.",
    errors: {
      callback_invalid_phone: "Entrez un numéro de 7 à 15 chiffres, avec l'indicatif du pays.",
      callback_missing_schedule: "Choisissez une date, une plage horaire et un fuseau horaire.",
      callback_invalid_window: "Choisissez le matin, l'après-midi ou l'un ou l'autre.",
      callback_invalid_timezone: "Choisissez un fuseau horaire valide.",
      callback_invalid_date: "Choisissez une date valide.",
      callback_future_required: "Choisissez une date à partir de demain dans le fuseau sélectionné.",
      callback_weekday_required: "Choisissez un jour de semaine, du lundi au vendredi.",
    },
  },
  es: {
    date: "Fecha preferida", window: "Franja horaria", timezone: "Su zona horaria",
    choose: "Elegir una franja", morning: "Mañana · 9:00–12:00",
    afternoon: "Tarde · 12:00–17:00", either: "Cualquiera · 9:00–17:00",
    note: "Días laborables, a partir de mañana. Su franja preferida es una solicitud, no una cita confirmada.",
    success: "Ya recibimos su solicitud de llamada.", requested: "Llamada solicitada",
    next: "Le responderemos en un día hábil para confirmar una hora con el experto adecuado.",
    errors: {
      callback_invalid_phone: "Introduzca un número de 7 a 15 dígitos, incluido el código de país.",
      callback_missing_schedule: "Elija una fecha, una franja y una zona horaria para la llamada.",
      callback_invalid_window: "Elija mañana, tarde o cualquiera.",
      callback_invalid_timezone: "Elija una zona horaria válida.",
      callback_invalid_date: "Elija una fecha válida.",
      callback_future_required: "Elija una fecha a partir de mañana en la zona horaria seleccionada.",
      callback_weekday_required: "Elija un día laborable, de lunes a viernes.",
    },
  },
};

export const visitorTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export function localToday(zone) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: zone, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date());
  const part = (type) => parts.find((p) => p.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}

export function callbackMinimumDate(zone) {
  const date = new Date(`${localToday(zone)}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + 1);
  return date.toISOString().slice(0, 10);
}

export function callbackError(form) {
  if (form.followup !== "phone") return "";
  const digits = form.phone.replace(/\D/g, "");
  if (digits.length < 7 || digits.length > 15) return "callback_invalid_phone";
  if (!form.callback_date || !form.callback_window || !form.callback_timezone) return "callback_missing_schedule";
  const day = new Date(`${form.callback_date}T12:00:00Z`);
  if (Number.isNaN(day.getTime())) return "callback_invalid_date";
  if (form.callback_date <= localToday(form.callback_timezone)) return "callback_future_required";
  if ([0, 6].includes(day.getUTCDay())) return "callback_weekday_required";
  return "";
}

export function callbackSummary(form, locale) {
  const date = new Date(`${form.callback_date}T12:00:00Z`);
  const displayDate = new Intl.DateTimeFormat(locale, {
    timeZone: "UTC", weekday: "long", year: "numeric", month: "short", day: "numeric",
  }).format(date);
  return `${displayDate} · ${CALLBACK_COPY[locale][form.callback_window]} · ${form.callback_timezone.replace(/_/g, " ")}`;
}